export async function clearAppCache(): Promise<void> {
    if (!("caches" in window)) return;
  
    try {
      const cacheNames: readonly string[] = await caches.keys();
  
      await Promise.all(
        cacheNames.map((cacheName: string) => caches.delete(cacheName))
      );
  
      console.info("Service worker cache cleared");
    } catch (error) {
      console.error("Cache clear failed", error);
    }
  }
  